import { types, getEnv } from 'mobx-state-tree';
import StringResources from './nls/StringResources';

export const VisTypeModel = types
	.model('VisTypeModel', {
		filter: types.optional(types.array(types.string), []),
		chartSpecs: types.optional(types.frozen(), {}),
		chartSpecsState: types.optional(types.enumeration('chartSpecsState', ['loading', 'loaded', 'empty']), 'empty')
	})
	.views(self => ({
		getChartSpecs(usageId) {
			try {
				if (self.chartSpecsState === 'empty') {
					self.setChartSpecsStateToLoading();
					const visDefinitions = getEnv(self).visDefinitions;
					const visDefsByUsage = self.getVisDefsByUsage({ excludeIds: self.filter, visDefinitions });
					self.updateChartSpecs(visDefsByUsage);
				} else if (self.chartSpecsState === 'loaded') {
					return self.chartSpecs[usageId];
				}
				return;
			} catch (e) {
				self.setChartSpecsStateToEmpty();
			}
		},
		/**
		 * @param options - an object that can be used to control what definitions/usages are returned.
		 *			excludeIds: an array of definition ids to be excluded from any Usage(s) it is assigned to
		 *			visDef: vis definition manager to source bundle definitions
		 *
		 * @returns vis definitions organized into a set of 'usages'
		 *			(a user-oriented grouping of visualization types (stored in the 'usages' member of each visualization definition (or in VIPRConfig)).
		 *			NOTE: A visualization can belong to 1 or more usages.
		 */
		getVisDefsByUsage(options={ excludeIds:[], visDefinitions:[] }) {
			const rtnUsageMapJSON = {};
			const excludedBundleIds = options.excludeIds;
			const visDefinitions = options.visDefinitions;

			const updateUsageMapEntry = function(usageId, visBundle) {
				//Augment a single entry in the usageMap with this visBundle
				const usageEntry = rtnUsageMapJSON[usageId] || {};
				usageEntry.usageId=usageId;
				//Save the localized label for the usage into the JSON.
				usageEntry.usageLabel=StringResources.get('visUsage' + usageId);
				usageEntry.chartTypes = usageEntry.chartTypes || [];
				usageEntry.chartTypes.push(visBundle);
				rtnUsageMapJSON[usageId] = usageEntry;
			};

			visDefinitions.forEach((visDef) => {
				if (excludedBundleIds.indexOf(visDef.getId()) === -1) {
					const visDescription  = {
						description: visDef.getLabel(),
						iconUri: visDef.getIcon(),
						id: visDef.getId(),
						minimalVisId: visDef.getId(),
						name: visDef.getLabel(),
						placeholderIcon: visDef.getPlaceholderIconUri(),
						usages: visDef.getProperty('usages'),
						visIds: [visDef.getId()]
					};
					const usages = visDescription.usages || ['Other'];
					usages.forEach((usageId) => {
						updateUsageMapEntry(usageId, visDescription);
					});
				}
			});
			return rtnUsageMapJSON;

		}
	}))
	.actions(self => ({
		updateChartSpecs(specs) {
			self.chartSpecs = specs;
			self.chartSpecsState = 'loaded';
		},
		setChartSpecsStateToLoading() {
			self.chartSpecsState = 'loading';
		},
		setChartSpecsStateToEmpty() {
			self.chartSpecsState = 'empty';
		}
	}));



// WEBPACK FOOTER //
// ./src/js/lib/@waca/vis-type-picker/src/js/VisTypeModel.js